<div class="mon-dialog-header">
  <mon-page-header
    [monIconDirect]="'faDownload'"
    [header]="'My Exports' | translate"
    [subHeader]="pages.total + ' ' + (pages.total === 1 ? ('export' | translate) : ('exports' | translate))">
  </mon-page-header>
</div>
<div class="mon-dialog-body">
  <div class="card panel-monsido-card mt-4 mx-4">
    <div class="card-body">
      <mon-table-container
        [collection]="pages"
        (pageChangeEvent)="onPageChange($event)"
        (perPageChange)="onPageSizeChange($event)"
        [loading]="progress"
        [noResultMessage]="'No exports available' | translate">
      <div class="table-container-body">
        <table class="table table-hover table-fixed">
          <thead>
            <tr>
              <th class="col-sm-8 col-md-8">
                <span translate>Category</span>
              </th>
              <th class="col-sm-4 col-md-4">
                <span translate>State</span>
              </th>
              <th class="col-sm-16 col-md-16">
                <span translate>Domain</span>
              </th>
              <th class="col-sm-8 col-md-8">
                <span translate>Error Name</span>
              </th>
              <th class="col-sm-4 col-md-4 text-right">
                <span translate>Created At</span>
              </th>
              <th class="col-sm-8 col-md-8 text-right">
                <span translate>Download</span>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let page of pages">
              <td class="text-ellipsis text-capitalize text-v-middle">
                {{ page.category | exportName }}
              </td>
              <td class="text-v-middle text-capitalize">
                {{ page.state }}
              </td>
              <td class="text-v-middle">
                <div *ngIf="page.category === 'scan_history_overview' || page.category === 'urls_with_policy_across_domains' || page.category === 'users_with_domain_access'">{{'Customer Report' | translate}}</div>
                <mon-url-title
                  *ngIf="page.category !== 'scan_history_overview' && page.category !== 'urls_with_policy_across_domains' && page.category !== 'users_with_domain_access'"
                  [url]="getDomainObjFromId(page.source_id, page.source_type)?.url"
                  [title]="getDomainObjFromId(page.source_id, page.source_type)?.title"
                  [active]="false"
                  (click)="goToDomain(getDomainObjFromId(page.source_id, page.source_type))"
                  (keydown.enter)="goToDomain(getDomainObjFromId(page.source_id, page.source_type))"
                  >
                </mon-url-title>
              </td>
              <td class="text-v-middle">
                {{ page.category_ref | translate }}
              </td>
              <td class="text-v-middle text-right">
                {{ page.created_at | date: 'medium' }}
              </td>
              <td class="text-v-middle text-right">
                <a *ngIf="page.state === 'ready'" class="btn btn-border-radius btn-secondary text-link" [href]="page.data_url" target="_blank">
                  <span class="fas fa-download mr-1"></span><span translate>Download</span>
                </a>
                <a *ngIf="page.state !== 'ready'" class="btn btn-border-radius btn-secondary text-link" disabled>
                  <span class="fas fa-download mr-1"></span><span translate>Download</span>
                </a>
              </td>
            </tr>
          </tbody>
        </table>
        </div>
      </mon-table-container>
    </div>
  </div>
</div>
